export const DEFAULT_LABEL = "Guest identifier";
export const labelOf = (label) => (label || "").trim() || DEFAULT_LABEL;

export const keyOf = (s) => (s || "").toLocaleLowerCase().split(/\s+/).filter(Boolean).join(" ");
export const fullName = (g) => [g.first_name, g.last_name].filter(Boolean).join(" ");

export const primaryLine = (g) => fullName(g) || g.display_name || g.identifier;

export const secondaryLine = (g) => {
  const first = primaryLine(g);
  const parts = first === g.identifier ? [] : [g.identifier];
  if (g.display_name && g.display_name !== first) parts.push(g.display_name);
  return parts.join(" · ");
};

export const splitName = (displayName) => {
  const words = (displayName || "").trim().split(/\s+/).filter(Boolean);
  return { first_name: words[0] || "", last_name: words.slice(1).join(" ") };
};

export const matches = (guest, query) => {
  const q = keyOf(query);
  if (!q) return true;
  return [guest.identifier, guest.display_name, guest.first_name, guest.last_name, fullName(guest)].some((v) => keyOf(v).includes(q));
};

const after = (a, b) => a.identifier_key > b.identifier_key || (a.identifier_key === b.identifier_key && a.created_at > b.created_at);

export const insertSorted = (list, guest) => {
  const i = list.findIndex((g) => after(g, guest));
  return i === -1 ? [...list, guest] : [...list.slice(0, i), guest, ...list.slice(i)];
};

export const replaceGuest = (list, guest) => list.map((g) => (g.id === guest.id ? guest : g));

export const newRequestId = () =>
  window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const isNetworkError = (err) => !err?.response;

const norm = (v) => (v ?? "").trim();
// Only fields the user actually changed, so Save never blanks a value that wasn't touched.
export const changedFields = (guest, form) =>
  Object.fromEntries(Object.entries(form).filter(([k, v]) => norm(v) !== norm(guest[k])));
